// Utilidades de traducción de catálogos de ComPsych

export const translatePresentingIssue = (value?: string) => {
  switch (value) {
    case 'After Care Program': return 'Programa de seguimiento';
    case 'Alcohol/Related': return 'Alcohol / Relacionado';
    case 'Anger Issues': return 'Problemas de ira';
    case 'Anxiety Related': return 'Ansiedad';
    case 'Bereavement/Grief': return 'Duelo';
    case 'Depression Related': return 'Depresión';
    case 'Domestic Violence': return 'Violencia doméstica';
    case 'Family/Child': return 'Familia / Niño';
    case 'Medical': return 'Médico';
    case 'Occupational - Job Loss': return 'Laboral - Pérdida de empleo';
    case 'Stress': return 'Estrés';
    case 'Trauma': return 'Trauma';
    // ... Agrega más según el catálogo
    default: return value || '-';
  }
};

export const translateGender = (value?: string) => {
  switch (value) {
    case 'Male': return 'Masculino';
    case 'Female': return 'Femenino';
    case 'Other': return 'Otro';
    case 'Non-Binary': return 'No binario';
    case 'Transgender': return 'Transgénero';
    case 'Not Specified': return 'No especificado';
    case 'Decline': return 'Prefiere no decirlo';
    default: return value || '-';
  }
};

export const translateLengthOfService = (value?: string) => {
  switch (value) {
    case 'Less than 1 year': return 'Menos de 1 año';
    case '1 - 4 years': return '1 - 4 años';
    case '5 - 9 years': return '5 - 9 años';
    case '10 - 14 years': return '10 - 14 años';
    case '15 - 19 years': return '15 - 19 años';
    case '20+ years': return 'Más de 20 años';
    case 'Unknown': return 'Desconocido';
    case 'Decline': return 'Prefiere no decirlo';
    default: return value || '-';
  }
};

export const translateEmployeeRelationship = (value?: string) => {
  switch (value) {
    case 'Employee': return 'Empleado';
    case 'Dependent': return 'Dependiente';
    case 'Spouse': return 'Cónyuge';
    case 'Other': return 'Otro';
    default: return value || '-';
  }
};

export const translateDeliveryMethod = (value?: string) => {
  switch (value) {
    case 'FACE_TO_FACE':
    case 'Face to face':
    case 'Face to Face':
      return 'Presencial';
    case 'TELEPHONE':
    case 'Telephone':
    case 'Phone':
    case 'PHONE':
      return 'Teléfono';
    case 'VIDEO':
    case 'Video':
      return 'Video';
    case 'CHAT':
    case 'Chat':
      return 'Chat';
    case 'TEXT':
    case 'Text':
      return 'Texto';
    default:
      return value || '-';
  }
};

export const translateRiskType = (value?: string) => {
  switch (value) {
    case 'No Risk': return 'Sin riesgo';
    case 'Homicidal': return 'Riesgo homicida';
    case 'Suicidal': return 'Riesgo suicida';
    default: return value || '-';
  }
};

export const translateEmployeeType = (value?: string) => {
  switch (value) {
    case 'Local-National': return 'Nacional';
    case 'International Assignee': return 'Asignado internacional';
    default: return value || '-';
  }
};

export const translateReferralSource = (value?: string) => {
  switch (value) {
    case 'Online': return 'En línea';
    case 'Email': return 'Correo electrónico';
    case 'HR': return 'Recursos Humanos';
    case 'Supervisor/Manager': return 'Supervisor/Gerente';
    case 'Unknown': return 'Desconocido';
    case 'Decline': return 'Prefiere no decirlo';
    default: return value || '-';
  }
};

export const translateAgeRange = (value?: string) => {
  switch (value) {
    case '0-12': return '0-12';
    case '13-19': return '13-19';
    case '20-29': return '20-29';
    case '30-39': return '30-39';
    case '40-49': return '40-49';
    case '50-59': return '50-59';
    case '60 +': return '60+';
    case 'Unknown': return 'Desconocido';
    case 'Decline': return 'Prefiere no decirlo';
    default: return value || '-';
  }
};
